import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import { TCoreLabels } from "../types/core-label-types";
import coreDefaultLabels from "./default-labels";

export interface TLabels extends TCoreLabels {}

export const defaultNamespace = "translation" as const;

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: typeof defaultNamespace;
    resources: {
      [defaultNamespace]: TLabels;
    };
  }
}

const corei18n = i18n.createInstance();
corei18n.use(initReactI18next);

const i18NextOptions: InitOptions = {
  lng: "sv",
  supportedLngs: ["sv", "en"],
  fallbackLng: "sv",
  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    sv: {
      [defaultNamespace]: coreDefaultLabels.sv,
    },
    en: {
      [defaultNamespace]: coreDefaultLabels.en,
    },
    nn: {},
  },
};

corei18n.init(i18NextOptions);

export default corei18n;
